module.exports = __webpack_public_path__ + "img/new-wally-bath.7f5e99d8.png";